import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authApi, tokenStore, formatErr } from "./api";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const data = await authApi.login(email, password);
      tokenStore.set(data);
      nav("/admin");
    } catch (e) {
      setErr(formatErr(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center p-6" data-testid="admin-login-page">
      <meta name="robots" content="noindex,nofollow"/>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mono text-[10px] uppercase tracking-[0.25em] text-prestige">Admin CMS</div>
          <h1 className="font-serif text-4xl text-navy mt-3 tracking-tight">Dr. Tania Gurdip Singh</h1>
          <div className="h-px w-10 bg-prestige mx-auto mt-6"/>
        </div>
        <div className="bg-white border border-line p-8">
          <div className="flex items-center gap-2 mono text-[10px] uppercase tracking-widest text-prestige mb-6">
            <ShieldCheck size={14} strokeWidth={1.5}/> Confidential Access
          </div>
          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <label className="block">
              <div className="mono text-[10px] uppercase tracking-widest text-stone2 mb-1.5">Email</div>
              <input data-testid="login-email" type="email" required value={email} onChange={e=>setEmail(e.target.value)}
                className="w-full bg-white border border-line px-3.5 py-2.5 text-sm focus:outline-none focus:border-navy"/>
            </label>
            <label className="block">
              <div className="mono text-[10px] uppercase tracking-widest text-stone2 mb-1.5">Password</div>
              <input data-testid="login-password" type="password" required value={password} onChange={e=>setPassword(e.target.value)}
                className="w-full bg-white border border-line px-3.5 py-2.5 text-sm focus:outline-none focus:border-navy"/>
            </label>
            {err && <div data-testid="login-error" className="text-sm text-[#9F1239] bg-warn border border-[#9F1239]/20 px-3 py-2">{err}</div>}
            <button type="submit" data-testid="login-submit" disabled={loading}
              className="w-full bg-navy hover:bg-navy-hover text-white text-sm font-medium py-3 rounded-none disabled:opacity-60">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
        <p className="text-xs text-stone2 mt-6 text-center">This area is for authorised personnel only. All actions are audit-logged.</p>
      </div>
    </div>
  );
}
